import { render } from "./tools-to-power-your-trades-and-investments-july-2024.vue?vue&type=template&id=58941a50"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__